
























































































































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { getChannelOption, setContentSeq } from '@/api/common'
import { ISpecialDisplay } from '@/api/content/content-special/res'
import {
  getSpecialDisplayList,
  addEditSpecailDisplay,
  setSpecialTop,
  deleteSpecial,
  getSpecialEditInfo
} from '@/api/content/content-special/special'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  setHighArr2lowArr,
  compareDate,
  deepCopy
} from '@/utils/tool'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'
import { getChaos, getCookie, getImgURLOfBase64 } from '@/utils/fix'

type channelType = 311 | 312
type bannerChannel = 360 | 361
type isTrue = 1 | -1
const domain = 'http://pics.tutuapp.com/'

@Component({
  name: 'ContentSpecialDisplay'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    nid: 0,
    ids: '',
    name: '',
    editor: '',
    status: '',
    updateDateStart: '',
    updateDateEnd: '',
    createDateStart: '',
    createDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private addParams = {
    id: 0,
    specialSeq: 0,
    isIos: 1, // 1：ios 3：android
    specialNids: [],
    startDate: '',
    endDate: '',
    isShow: 1,
    isBanner: -1,
    bannerType: '专题',
    bannerTypeId: 1,
    bannerSeq: 0,
    bannerNids: [],
    url: '',
    bannerId: 0
  }
  private channelCascaderKey = 0
  private bannerCascaderKey = 0
  // component data
  tableLoading = false
  private disabled: boolean = false
  private tableData: ISpecialDisplay[] = []
  private selectedData: ISpecialDisplay[] = []
  private selectList: any[] = [] // 级联选择
  private value: number[] = [] // 级联选中项
  private dateArray1: string[] = ['', '']
  private dateArray2: string[] = ['', '']
  private totalCount: number = 0
  routeQuery: IQuery = { id: 0 }
  private addFormVisible: boolean = false
  private rules: any = {
    id: [
      {
        type: 'number',
        required: true,
        message: '请填写专题id且为数字',
        trigger: 'blur'
      }
    ],
    specialSeq: [
      {
        type: 'number',
        required: true,
        message: '请填写排序且为数字',
        trigger: 'blur'
      }
    ],
    startDate: [
      {
        required: true,
        message: '请选择开始时间',
        trigger: 'blur'
      }
    ],
    endDate: [
      {
        required: false,
        message: '请选择结束时间',
        trigger: 'blur'
      }
    ]
  }
  // 上架渠道
  private channelList: any[] = []
  private channelOption: any[] = []
  private bannerChannelList: any[] = []
  private bannerChannelOption: any[] = []
  tableHeight: number = 500
  // lifecycle
  async created() {
    await this.getChannelOption()
    await this.getTableData()
    // form级联初始化
    let pid: channelType = this.platform === 'ios' ? 311 : 312
    let bPid: bannerChannel = this.platform === 'ios' ? 360 : 361
    await this.getUpChannel(pid)
    await this.getBannerPositionChannel(bPid)
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.setTableHeight)
  }
  // methods
  async getChannelOption() {
    // 顶部菜单
    let res = await getChannelOption({
      type: 2,
      pos: 'top',
      pid: 310
    })
    this.selectList = res.data
    this.value = [311, 313, 329]
    this.params.nid = this.value[2]
  }
  async getTableData() {
    this.tableLoading = true
    let res = await getSpecialDisplayList(this.params)
    let dataList = res.data.dataList || []
    let buildEnv = process.env.VUE_APP_ENV || ''
    if (buildEnv !== 'env') {
      this.tableData = dataList
      this.tableLoading = false
      this.totalCount = res.data.pageInfo.totalCount
      return false
    }
    this.tableData = []
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    // this.tableLoading = false
    const cover: string = require('@/assets/images/loading.svg')
    dataList.forEach((item: any) => {
      let el = { ...item }
      el.icon = cover
      this.tableData.push(el)
    })
    this.totalCount = res.data.pageInfo.totalCount
    for (let i = 0; i < dataList.length; i++) {
      getImgURLOfBase64(dataList[i].icon, header).then(res => {
        this.tableData[i]['icon'] = res as string
      })
    }
    this.tableLoading = false
    this.totalCount = res.data.pageInfo.totalCount
  }
  cloneTable(list: any[]) {
    list = list || []
    let arr: any[] = []
    list.forEach((item: any) => {
      let copyItem: any = { ...item }
      copyItem.icon = ''
      arr.push(copyItem)
    })
    return arr
  }
  async handleExcel() {
    // let excelParams = deepCopy(this.params)
    // let res: any = await getSpecialDisplayList(
    //   Object.assign(excelParams, {
    //     page: 1,
    //     pageCount: 3000
    //   })
    // )
    // if (res.status.code === 0) {
    //   this['$message'].success('导出成功')
    // } else {
    //   this['$message'].error('导出失败')
    //   return
    // }
    const filterVal: string[] = [
      'seq',
      'id',
      'name',
      'isShow',
      'startDate',
      'endDate',
      'viewCount',
      'appCount',
      'editor'
    ]
    const theader: string[] = [
      '排序',
      'ID',
      '应用名',
      '是否展示(1:是, -1:否)',
      '开始展示时间',
      '结束展示时间',
      '查看量',
      '应用数量',
      '编辑人'
    ]
    if (this.selectedData.length <= 0) {
      return this.$message.warning('请选择数据')
    }
    const list = this.selectedData
    const data = formatJson(filterVal, list)
    exportJson2Excel(theader, data)
    this['$message'].success('导出成功!')
    ;(this.$refs['multiTable'] as any).clearSelection()
  }
  async getUpChannel(pid: channelType) {
    let res: any = await getChannelOption({
      type: 2,
      pos: 'all',
      pid: pid
    })
    this.channelOption = res.data
    ++this.channelCascaderKey // 解决多组件数组重复问题
  }
  async getBannerPositionChannel(pid: bannerChannel) {
    let res: any = await getChannelOption({
      type: 3,
      pos: 'all',
      pid: pid
    })
    this.bannerChannelOption = res.data
    ++this.bannerCascaderKey
  }
  async addEditSpecailDisplay() {
    this.tableLoading = true
    let res: any = await addEditSpecailDisplay(
      Object.assign(this.addParams, {
        url: this.addParams.url.split(domain).pop() as string
      })
    )
    if (res.status.code === 0) {
      this['$message'].success('发布成功')
      this.cancelAddForm()
    } else {
      this['$message'].error('发布失败!')
    }
    this.tableLoading = false
  }
  async setSpecialTop(ids: string) {
    let res: any = await setSpecialTop({
      nid: Number(this.params.nid),
      ids: ids,
      isTop: 1
    })
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
    } else {
      this['$message'].error('操作失败')
    }
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  handleInput(val: string, attr: string) {
    (this.params as any)[attr] = val.replace(/[^0-9]/g, '')
  }
  deleteSpecial(ids: string) {
    this.$confirm('确认删除该数据?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        let res: any = await deleteSpecial({
          nid: Number(this.params.nid),
          ids: ids
        })
        if (res.status.code === 0) {
          this['$message'].success('删除成功')
          this.getTableData()
        } else {
          this['$message'].error('删除失败')
        }
      })
      .catch(() => {})
  }
  async getSpecialEditInfo(id: number, nid: number) {
    this.tableLoading = true
    let res: any = await getSpecialEditInfo({ id, nid })
    if (res.status.code === 0) {
      let obj = res.data

      this.addParams.id = id
      this.addParams.specialSeq = obj.specialSeq
      // specialNids
      this.channelList = obj.specialNids.splice(0)
      this.addParams.specialNids = setHighArr2lowArr(
        this.channelList
      ) as never[]
      this.addParams.startDate = obj.startDate
      this.addParams.endDate = obj.endDate
      this.addParams.isShow = obj.isShow
      this.addParams.isBanner = obj.isBanner
      this.addParams.bannerTypeId = obj.bannerTypeId
      this.addParams.bannerSeq = obj.bannerSeq
      // bannerNids
      this.bannerChannelList = obj.bannerNids && obj.bannerNids.splice(0)
      this.addParams.bannerNids = setHighArr2lowArr(
        this.bannerChannelList
      ) as never[]
      this.addParams.url = obj.url
      this.addParams.bannerId = obj.bannerId
      this.addFormVisible = true
    }
    this.tableLoading = false
  }
  // 切换一级分类
  async handleSelectOne(v: number[]) {
    let pid = v[2]
    this.params.nid = pid
    await this.getTableData()
    this.addParams.isIos = this.platform === 'ios' ? 1 : 3
    // 表单数据请求
    let ppid: channelType = this.platform === 'ios' ? 311 : 312
    let bPid: bannerChannel = this.platform === 'ios' ? 360 : 361
    await this.getUpChannel(ppid)
    await this.getBannerPositionChannel(bPid)
  }
  handleDateChange1(date: string[]) {
    this.params.updateDateStart = date && date[0]
    this.params.updateDateEnd = date && date[1]
  }
  handleDateChange2(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  handleSearch() {
    if (this.tableLoading) { return false }
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['nid', 'page', 'pageCount'])
    this.params.page = 1
    this.dateArray1 = ['', '']
    this.dateArray2 = ['', '']
    this.getTableData()
  }
  handleAdd() {
    this.addFormVisible = true
    // this.$router.push('./content-special-add')
  }
  handleSelectionChange(list: ISpecialDisplay[]) {
    this.selectedData = list
  }
  handleSelectAll() {
    // 如果没有选择全部, 则寻找未选择的行, 并将这些行选中
    if (this.selectedData.length < this.tableData.length) {
      let tempSelectList = this.selectedData.map(item => item.id)
      let unSelected: any[] = this.tableData.filter((item: any) => !tempSelectList.includes(item.id))
      unSelected.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })

    // this.selectedData = this.tableData.filter(item => indexList.includes(item.id))
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleRemoveAll() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    this.deleteSpecial(ids)
  }
  async setTopApp(item: ISpecialDisplay) {
    let ids = item.id.toString()
    await this.setSpecialTop(ids)
    await this.getTableData()
  }
  updateApp(item: ISpecialDisplay) {
    const { id } = item
    const nid = this.params.nid
    // this.$router.push({ path: './content-special-add', query: { id: id.toString(), nid } })
    this.getSpecialEditInfo(id, nid)
  }
  removeApp(item: ISpecialDisplay) {
    let ids = item.id.toString()
    this.deleteSpecial(ids)
  }
  handleChangeChannel(list: number[][]) {
    this.addParams.specialNids = setHighArr2lowArr(list) as never[]
  }
  handleChangeChannelPos(list: number[][]) {
    this.addParams.bannerNids = setHighArr2lowArr(list) as never[]
  }
  cancelAddForm() {
    // 重置参数
    (this.$refs['addParams'] as Form).resetFields()
    this.channelList = []
    this.bannerChannelList = []
    this.addParams.specialNids = []
    this.addParams.isShow = -1
    this.addParams.isBanner = -1
    this.addParams.bannerTypeId = 1
    this.addParams.bannerSeq = 0
    this.addParams.bannerNids = []
    this.addParams.url = ''
    this.addParams.bannerId = 0
    this.addFormVisible = false
  }
  confirmAddForm() {
    (this.$refs['addParams'] as Form).validate(valid => {
      this.tableLoading = true
      let leng = this.addParams.specialNids.length
      if (valid && leng !== 0) {
        if (this.showBanner) {
          // 进一步验证
          let isNone =
            String(this.addParams.bannerSeq) === '' ||
            this.addParams.bannerNids.length === 0 ||
            this.addParams.url === '' || !this.addParams.startDate
          if (isNone) {
            this['$message'].warning('请填写缺失参数!')
            this.tableLoading = false
            return
          }
          // let isDateValid = compareDate(
          //   this.addParams.startDate,
          //   this.addParams.endDate
          // )
          // if (!isDateValid) {
          //   this['$message'].warning('上架结束时间必须大于上架开始时间')
          //   this.tableLoading = false
          //   return
          // }
          this.addEditSpecailDisplay()
          this.tableLoading = false
        } else {
          this.addEditSpecailDisplay()
          this.tableLoading = false
        }
      } else {
        this['$message'].error('请填写缺失参数!')
        this.tableLoading = false
        return false
      }
    })
  }
  async handleEdit(i: number, item: ISpecialDisplay) {
    const { id, seq } = item
    if (typeof seq === 'string' && seq === '') {
      this['$message'].warning('请输入排序!')
      return false
    } else if (seq <= 0) {
      this['$message'].warning('排序不得小于等于0!')
      return false
    }
    let nid = this.params.nid
    console.log(nid, id, i)
    let res: any = await setContentSeq({
      nid: Number(nid),
      relateId: id,
      seq: seq
    })
    if (res.status.code === 0) {
      this['$message'].success('操作成功')
      await this.getTableData()
    } else {
      this['$message'].error('操作失败')
    }
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get showBanner() {
    return this.addParams.isBanner === 1
  }
  get platform() {
    return (this.value && this.value[0]) === 311 ? 'ios' : 'android'
  }
}
